export default "__VITE_ASSET__BdYoiS12__"